<template>
  <div class="page-toggle-container" :class="classes">
    <div class="flex flex-full flex-justify-center flex-align-items-center">
      <div class="flex flex-align-items-center">
        <a class="toggle-text" :class="active === 'content' ? 'active' : ''" :href="contentUrl">{{
          contentTitle
        }}</a>

        {{/* switch */}}
        <div class="page-toggle" role="button" tabindex="0" @click.prevent.once="toggleSwitch">
          <span class="toggle-tab" :class="active === 'content' ? 'active' : ''">
            <i class="material-icons-outlined md-light">subject</i>
          </span>
          <span class="toggle-tab" :class="active === 'dashboard' ? 'active' : ''">
            <i class="material-icons-outlined md-light">dashboard</i>
          </span>
        </div>

        {{/* show link if on the "content" page, other wise show SPA router link */}}
        <a
          v-if="active === 'content'"
          class="toggle-text -new"
          :class="active === 'dashboard' ? 'active' : ''"
          :href="dashboardUrl"
        >
          {{ dashboardTitle }}
          <span class="new-feature">New</span>
        </a>
        <router-link
          v-else
          class="toggle-text -new"
          :class="active === 'dashboard' ? 'active' : ''"
          :to="dashboardUrl"
        >
          {{ dashboardTitle }}
          <span class="new-feature">New</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @flow

export default {
  name: 'DashboardToggleBar',
  components: {},
  props: {
    classes: {
      type: String,
      default: '',
    },
    initActive: {
      type: String, // content | dashboard
      default: 'content',
    },
    contentUrl: {
      type: String,
      required: true,
    },
    contentTitle: {
      type: String,
      default: 'details',
    },
    dashboardUrl: {
      type: String,
      required: true,
    },
    dashboardTitle: {
      type: String,
      default: 'dashboard',
    },
  },

  // component state
  data() {
    return {
      active: this.initActive,
    }
  },

  // lifecycle methods

  // component methods
  methods: {
    toggleSwitch() {
      if (this.active === 'dashboard') {
        return (window.location.href = this.contentUrl)
      }

      return (window.location.href = this.dashboardUrl)
    },
  },
}
</script>
